// Global search DAO — thin wrapper over the `global_search` RPC.
// Used by the command-K search modal and by entity-list quick-filters that
// need a full-text search component as part of their PostgREST filter chain.

import type { PostgrestError } from '@supabase/supabase-js';
import type { SupabaseClient } from '../base.ts';

export interface GlobalSearchHit {
  entity: string;
  id: number;
  id_text: string | null;
  label: string;
  sublabel: string;
  rank: number;
}

export class GlobalSearchDao {
  constructor(private readonly sb: SupabaseClient) {}

  async search(
    query: string,
    entities: string[] | undefined,
    limit: number,
  ): Promise<GlobalSearchHit[]> {
    // The client is schema-untyped, so the RPC response is `any` — narrow it here
    // rather than letting `any` leak into the caller.
    const { data, error } = (await this.sb.rpc('global_search', {
      p_query: query,
      p_entities: entities,
      p_limit: limit,
    })) as { data: GlobalSearchHit[] | null; error: PostgrestError | null };
    if (error) throw error;
    return data ?? [];
  }
}
